export const TYPES = {
  SEQUENTIAL: 'sequential',
  SEPARATED: 'separated',
};
